export default () => ({
  listWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  }
});
